// extracted by mini-css-extract-plugin
export var markdown = "_sa-0";
export var tableWrapper = "_sa-1";